import React from 'react';
import { PolicyFromText } from '../../components/ui/PolicyFromText';
import { legalNotice } from '../../data/policies/legalNotice';
export function LegalNotice() {
  return <PolicyFromText doc={legalNotice} data-id="element-1165" data-mp="b6j71b6kmm9d" />;
}